import { supabase } from "@/integrations/supabase/supabaseClient";

/**
 * Common authentication utilities for Supabase repositories
 */
export class SupabaseAuthUtils {
  /**
   * Get the current authenticated user ID
   * @throws {Error} If user is not authenticated
   */
  static async getCurrentUserId(): Promise<string> {
    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (!user) {
      throw new Error("User not authenticated");
    }

    return user.id;
  }

  /**
   * Check if user is authenticated without throwing
   * @returns {Promise<string | null>} User ID or null if not authenticated
   */
  static async getCurrentUserIdSafe(): Promise<string | null> {
    try {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      return user?.id || null;
    } catch {
      return null;
    }
  }

  /**
   * Validate that user is authenticated and return user ID
   * @throws {Error} If user is not authenticated with descriptive message
   */
  static async requireAuthentication(): Promise<string> {
    const userId = await this.getCurrentUserIdSafe();

    if (!userId) {
      throw new Error("Authentication required to perform this operation");
    }

    return userId;
  }
}
